import React from 'react';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const LogoUploader = ({ logo, setLogo }) => {
  const handleLogoUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target?.result as string;
      setLogo(base64);
      localStorage.setItem('companyLogo', base64);
    };
    reader.readAsDataURL(file);
    return false;
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      <strong>Logo da Empresa:</strong>
      <Upload
        accept="image/*"
        beforeUpload={handleLogoUpload}
        showUploadList={false}
      >
        <Button
          className='ml-2 border-dashed'
          icon={<UploadOutlined />} block>
          {logo ? 'Alterar Logo' : 'Upload Logo'}
        </Button>
      </Upload>
      {logo && (
        <div style={{ marginTop: '8px', textAlign: 'center' }}>
          <img src={logo} alt="Logo" style={{ maxWidth: '100%', maxHeight: '60px' }} />
        </div>
      )}
    </div>
  );
};

export default LogoUploader;
